import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";
import { aiFillSettingsSchema, formCategorySchema, FormNS } from "./form";
import { TeamNS } from "./team";
import { UserNS } from "./user";

export const DeletedFormNS = buildNamespace({
  system,
  entity: "DeletedForm",
} as const);

export const DeletedFormSchema = z.object({
  uri: DeletedFormNS.schema,
  operationId: z.string(),

  formUri: FormNS.schema,
  teamUri: TeamNS.schema,
  createdBy: UserNS.schema,
  createdAt: z.string(),
  updatedBy: UserNS.schema,
  updatedAt: z.string(),
  deletedBy: UserNS.schema,
  deletedAt: z.string(),

  restoredAt: z.string().optional(),

  title: z.string(),
  response: z.string(),
  active: z.boolean().optional(),
  creationStatus: z.string().optional().nullable(),
  source: z.string().optional(),
  matterId: z.string().optional(),
  aiFillSettings: aiFillSettingsSchema.optional(),

  category: formCategorySchema,

  matterTypes: z.array(
    z.object({
      id: z.string(),
      source: z.string(),
      name: z.string(),
      category: z.string(),
      location: z.string(),
      representativeOptions: z.array(z.string()).optional(),
    }),
  ),

  // TTL fields
  deleted: z.boolean().optional(),
  deletedAtSec: z.number().optional(),
});

export type DeletedForm = z.infer<typeof DeletedFormSchema>;
